import { type FormEvent, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router'

import { useRegister } from '@/api/auth'
import { strings } from '@/lib/strings'

import { AuthForm, Field } from './AuthForm'
import { OAuthButtons } from './OAuthButtons'
import { authErrorMessage } from './errorMessage'
import { redirectTarget } from './redirect'

export function RegisterPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [displayName, setDisplayName] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const mutation = useRegister()
  const target = redirectTarget(location.state)

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    mutation.mutate(
      { email, password, displayName },
      {
        onSuccess: () => {
          void navigate(target, { replace: true })
        },
      },
    )
  }

  return (
    <AuthForm
      title={strings.auth.registerTitle}
      submitLabel={strings.auth.submitRegister}
      pending={mutation.isPending}
      error={authErrorMessage(mutation.error)}
      onSubmit={handleSubmit}
      aside={<OAuthButtons next={target} />}
      footer={
        <>
          {strings.auth.haveAccount}{' '}
          <Link to="/login" className="text-accent">
            {strings.auth.goToLogin}
          </Link>
        </>
      }
    >
      <Field
        id="email"
        label={strings.auth.email}
        type="email"
        value={email}
        autoComplete="email"
        required
        onChange={setEmail}
      />
      <Field
        id="password"
        label={strings.auth.password}
        type="password"
        value={password}
        autoComplete="new-password"
        required
        // Требования показаны сразу, а не после отправки формы (docs/10-ui-ux.md).
        hint={strings.auth.passwordRequirements}
        onChange={setPassword}
      />
      <Field
        id="display-name"
        label={strings.auth.displayName}
        type="text"
        value={displayName}
        autoComplete="nickname"
        onChange={setDisplayName}
      />

      <p className="rounded-lg border border-warning/50 p-3 text-sm text-warning">
        {strings.auth.noRecoveryWarning}
      </p>
    </AuthForm>
  )
}
